var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowToChooseADataEngineeringCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1376 768",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Data pipeline with quality checks and the failure path a data engineering company should design",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1376,
    height: 768,
    fill: "#0B1E24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Outfit, Poppins, 'Segoe UI', Helvetica, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 110,
    fontSize: 15,
    fontWeight: 600,
    fill: "#4FD1C5",
    textAnchor: "start",
    letterSpacing: 2.4,
    opacity: 1
  }, "CHOOSING A DATA ENGINEERING COMPANY"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 164,
    fontSize: 40,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Ask about failure before you ask about tools"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 200,
    fontSize: 17,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "What should happen at 3am when a check fails. If the answer is silence, so is the pipeline."), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 300,
    width: 200,
    height: 72,
    rx: 12,
    fill: "#10303A",
    stroke: "#4FD1C5",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 330,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Source"), /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 352,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "ERP \xB7 CRM \xB7 events"), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 300,
    width: 200,
    height: 72,
    rx: 12,
    fill: "#10303A",
    stroke: "#4FD1C5",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 456,
    y: 330,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Ingest"), /*#__PURE__*/React.createElement("text", {
    x: 456,
    y: 352,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "batch + stream"), /*#__PURE__*/React.createElement("rect", {
    x: 616,
    y: 286,
    width: 260,
    height: 100,
    rx: 12,
    fill: "#10303A",
    stroke: "#4FD1C5",
    strokeWidth: 2,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 746,
    y: 320,
    fontSize: 17,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Quality checks"), /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 342,
    width: 42,
    height: 26,
    rx: 6,
    fill: "#0B1E24",
    stroke: "#2C5A62",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 653,
    y: 359,
    fontSize: 10,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "schem"), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 342,
    width: 42,
    height: 26,
    rx: 6,
    fill: "#0B1E24",
    stroke: "#2C5A62",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 701,
    y: 359,
    fontSize: 10,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "fresh"), /*#__PURE__*/React.createElement("rect", {
    x: 728,
    y: 342,
    width: 42,
    height: 26,
    rx: 6,
    fill: "#0B1E24",
    stroke: "#2C5A62",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 749,
    y: 359,
    fontSize: 10,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "volum"), /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 342,
    width: 42,
    height: 26,
    rx: 6,
    fill: "#0B1E24",
    stroke: "#2C5A62",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 797,
    y: 359,
    fontSize: 10,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "integ"), /*#__PURE__*/React.createElement("rect", {
    x: 824,
    y: 342,
    width: 42,
    height: 26,
    rx: 6,
    fill: "#0B1E24",
    stroke: "#2C5A62",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 845,
    y: 359,
    fontSize: 10,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "rules"), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 300,
    width: 200,
    height: 72,
    rx: 12,
    fill: "#10303A",
    stroke: "#4FD1C5",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 1036,
    y: 330,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Warehouse"), /*#__PURE__*/React.createElement("text", {
    x: 1036,
    y: 352,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "dbt \xB7 Snowflake / BigQuery"), /*#__PURE__*/React.createElement("rect", {
    x: 1196,
    y: 300,
    width: 84,
    height: 72,
    rx: 12,
    fill: "#10303A",
    stroke: "#4FD1C5",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 1238,
    y: 330,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "BI"), /*#__PURE__*/React.createElement("text", {
    x: 1238,
    y: 352,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296,
    y1: 336,
    x2: 356,
    y2: 336,
    stroke: "#4FD1C5",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 329 L356 336 L346 343",
    fill: "none",
    stroke: "#4FD1C5",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556,
    y1: 336,
    x2: 616,
    y2: 336,
    stroke: "#4FD1C5",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 329 L616 336 L606 343",
    fill: "none",
    stroke: "#4FD1C5",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 876,
    y1: 336,
    x2: 936,
    y2: 336,
    stroke: "#4FD1C5",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926 329 L936 336 L926 343",
    fill: "none",
    stroke: "#4FD1C5",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1136,
    y1: 336,
    x2: 1196,
    y2: 336,
    stroke: "#4FD1C5",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186 329 L1196 336 L1186 343",
    fill: "none",
    stroke: "#4FD1C5",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 386 L746 470",
    fill: "none",
    stroke: "#E0775B",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736 460 L746 472 L756 460",
    fill: "none",
    stroke: "#E0775B",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 770,
    y: 440,
    fontSize: 13,
    fontWeight: 700,
    fill: "#E0775B",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "check fails \u2192"), /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 480,
    width: 240,
    height: 72,
    rx: 12,
    fill: "#2A1A1E",
    stroke: "#E0775B",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 606,
    y: 510,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Quarantine"), /*#__PURE__*/React.createElement("text", {
    x: 606,
    y: 532,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "bad rows never land"), /*#__PURE__*/React.createElement("rect", {
    x: 766,
    y: 480,
    width: 240,
    height: 72,
    rx: 12,
    fill: "#2A1A1E",
    stroke: "#E0775B",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 886,
    y: 510,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Alert + runbook"), /*#__PURE__*/React.createElement("text", {
    x: 886,
    y: 532,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "a person, a procedure"), /*#__PURE__*/React.createElement("rect", {
    x: 1046,
    y: 480,
    width: 234,
    height: 72,
    rx: 12,
    fill: "#2A1A1E",
    stroke: "#E0775B",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 1163,
    y: 510,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Retry with backoff"), /*#__PURE__*/React.createElement("text", {
    x: 1163,
    y: 532,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "then halt, not guess"), /*#__PURE__*/React.createElement("line", {
    x1: 726,
    y1: 516,
    x2: 766,
    y2: 516,
    stroke: "#E0775B",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756 509 L766 516 L756 523",
    fill: "none",
    stroke: "#E0775B",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1006,
    y1: 516,
    x2: 1046,
    y2: 516,
    stroke: "#E0775B",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036 509 L1046 516 L1036 523",
    fill: "none",
    stroke: "#E0775B",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 630,
    fontSize: 15,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Then ask about ownership: warehouse, code and credentials are yours from day one, and your team can run it."), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 712,
    fontSize: 16,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 3,
    opacity: 1
  }, "WORKFLOX"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToChooseADataEngineeringCompany);
export default __webpack_public_path__ + "static/media/how-to-choose-a-data-engineering-company.ac8c9aa54a28f014850981591964534c.svg";
export { ForwardRef as ReactComponent };